import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search"]

  filter() {
    if (!this.hasSearchTarget) return

    const searchTerm =
      this.searchTarget && this.searchTarget.value.trim().length > 0
        ? this.searchTarget.value.trim().toLowerCase()
        : null

    let name
    document.querySelectorAll(".player-list .player-row").forEach((p) => {
      if (searchTerm) {
        name = p.dataset.name && p.dataset.name.trim().length > 0 ? p.dataset.name.trim().toLowerCase() : null
        if (name && name.match(searchTerm)) {
          p.style.display = ""
        } else {
          p.style.display = "none"
        }
      } else {
        p.style.display = ""
      }
    })
  }
}
